'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUrl = setUrl;
exports.setPath = setPath;
exports.setSearch = setSearch;
exports.setHash = setHash;
exports.setState = setState;

var _actionCreaters = require('./action-creaters');

function setUrl(url) {
  var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var setters = [{ fn: 'url', args: [url] }];
  if (replace) {
    setters.push({ fn: 'replace' });
  }
  return (0, _actionCreaters.setLocation)(setters);
}

function setPath(path) {
  var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var setters = [{ fn: 'path', args: [path] }];
  if (replace) {
    setters.push({ fn: 'replace' });
  }
  return (0, _actionCreaters.setLocation)(setters);
}

function setSearch(search, paramValue) {
  var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var setters = [];
  if (typeof search === 'string') {
    setters.push({ fn: 'search', args: [search, paramValue] });
    if (replace) {
      setters.push({ fn: 'replace' });
    }
  } else {
    setters.push({ fn: 'search', args: [search] });
    if (paramValue || replace) {
      setters.push({ fn: 'replace' });
    }
  }
  return (0, _actionCreaters.setLocation)(setters);
}

function setHash(hash) {
  var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var setters = [{ fn: 'hash', args: [hash] }];
  if (replace) {
    setters.push({ fn: 'replace' });
  }
  return (0, _actionCreaters.setLocation)(setters);
}

function setState(state) {
  var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var setters = [{ fn: 'state', args: [state] }];
  if (replace) {
    setters.push({ fn: 'replace' });
  }
  return (0, _actionCreaters.setLocation)(setters);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ng-redux-route/lib/location-helpers.js
// module id = 919
// module chunks = 0